import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { useParams } from 'react-router-dom';
import Modal from '@material-ui/core/Modal';
import Fade from '@material-ui/core/Fade';
import Backdrop from '@material-ui/core/Backdrop';
import Button from '@material-ui/core/Button';

import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { MENU_WIDTH } from '../constants';

import EditGroupModal from '../components/EditGroupModal.jsx';
import { getGroups, deleteGroup } from '../store/actions/admin';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    paddingLeft: MENU_WIDTH,
    paddingTop: '6rem',
  },
  top: {
    display: 'flex',
  },
  patient: {
    margin: '2rem 0 0 2rem',
    paddingRight: '1rem',
  },
  edit: {
    margin: '2rem 0 1rem 0',
    color: 'white',
    backgroundColor: '#00d1b2',
    '&:hover': {
      backgroundColor: '#00bca0',
    },
  },
  remove: {
    margin: '2rem 0 1rem 1rem',
    color: 'white',
    backgroundColor: '#00d1b2',
    '&:hover': {
      backgroundColor: '#00bca0',
    },
  },
  patientInfo: {
    margin: '0 0 0 2rem',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  column: {
    width: '48%',
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '90%',
  },
  paper: {
    padding: '2rem',
    paddingTop: '1rem',
    minWidth: 550,
    maxWidth: '700px',
    backgroundColor: theme.palette.background.paper,
    borderRadius: 4,
    boxShadow: theme.shadows[5],
    outline: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  sectionHead: {
    width: '100%',
    borderBottom: 'solid 2px gray',
    color: 'gray',
  },
  buttonRow: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: '2rem',
    width: '100%',
    justifyContent: 'space-around',
  },
  button: {
    width: '30%',
    margin: '-1rem 0 1rem 0',
    padding: '0.6rem',
    color: 'white',
    backgroundColor: '#00d1b2',
    '&:hover': {
      backgroundColor: '#00bca0',
    },
  },
}));

const GroupDetails = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = useParams();
  const groupsList = useSelector((state) => state.admin.groupsList);
  const [currentGroup, setCurrentGroup] = useState();
  const classes = useStyles();
  const [editGroupModalOpen, setEditGroupModalOpen] = useState(false);
  const [deleteGroupModalOpen, setRemoveGroupModalOpen] = useState(false);

  useEffect(() => {
    dispatch(getGroups());
  }, []);

  useEffect(() => {
    if (id && groupsList.length) {
      const match = groupsList.find((group) => group.id.toString() === id.toString());
      if (match) setCurrentGroup(match);
    }
  }, [groupsList, id]);

  const handleSubmit = () => {
    dispatch(deleteGroup(currentGroup.id));
    dispatch(getGroups());
    history.push('../groups');
  };

  if (currentGroup)
    return (
      <div className={classes.root}>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className={classes.modal}
          open={deleteGroupModalOpen}
          onClose={() => setRemoveGroupModalOpen(false)}
          closeAfterTransition
          BackdropComponent={Backdrop}
        >
          <Fade in={deleteGroupModalOpen}>
            <div className={classes.paper}>
              <h2 className={classes.title}>Remove Group</h2>
              <form className={classes.form} onSubmit={handleSubmit}>
                <div className={classes.sectionHead} />
                <h3 className={classes.title}>Are you sure you want to delete this group?</h3>
                <div className={classes.buttonRow}>
                  <Button
                    className={classes.button}
                    size="small"
                    variant="contained"
                    type="submit"
                    onClick={handleSubmit}
                  >
                    Delete
                  </Button>
                  <Button
                    className={classes.button}
                    size="small"
                    variant="contained"
                    onClick={() => setRemoveGroupModalOpen(false)}
                  >
                    Cancel
                  </Button>
                </div>
              </form>
            </div>
          </Fade>
        </Modal>
        <EditGroupModal open={editGroupModalOpen} setOpen={setEditGroupModalOpen} group={currentGroup} />
        <div className={classes.top}>
          <h2 className={classes.patient}>{`Group: ${currentGroup.name}`}</h2>
          <Button className={classes.edit} size="small" variant="contained" onClick={() => setEditGroupModalOpen(true)}>
            Edit
          </Button>
          <Button
            className={classes.remove}
            size="small"
            variant="contained"
            onClick={() => setRemoveGroupModalOpen(true)}
          >
            Remove
          </Button>
        </div>
        <div className={classes.patientInfo}>
          <div className={classes.column}>
            {currentGroup.members && currentGroup.members.length > 0 && (
              <p>
                <b>Members: </b>
                {currentGroup.members.map(
                  (user, index) =>
                    `${user.first_name} ${user.last_name}${index < currentGroup.members.length - 1 ? ', ' : ''}`,
                )}
              </p>
            )}
            {currentGroup.patients && currentGroup.patients.length > 0 && (
              <p>
                <b>Patients: </b>
                {currentGroup.patients.map(
                  (patient, index) =>
                    `${patient.first_name} ${patient.last_name}${index < currentGroup.patients.length - 1 ? ', ' : ''}`,
                )}
              </p>
            )}
          </div>
        </div>
      </div>
    );
  return null;
};

export default GroupDetails;
